import scrollIntoView from 'scroll-into-view-if-needed'

export function useValidation() {
  function getValidationError(feildName) {
    return this.validationErrors[feildName]
  }

  function hasValidationError(feildName) {
    return this.getValidationError(feildName) !== undefined
  }

  function scrollToErrors() {
    const errorsEls = Object.keys(this.validationErrors)
      // refs need to be named like this otherwise it will break
      .map(name => this.$refs[`field_${name}`])
      .filter(el => el !== undefined)

    const topValue = el => window.scrollY + el.getBoundingClientRect().top
    const highestEl = errorsEls.reduce(
      (current, next) => (topValue(next) < topValue(current) ? next : current),
      errorsEls[0]
    )

    scrollIntoView(highestEl, { behavior: 'smooth' })
  }

  return {
    validationErrors: {},
    getValidationError,
    hasValidationError,
    scrollToErrors,
  }
}
